// Set operations implementation from :
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#implementing_basic_set_operations
export function isSuperset(set, subset) {
  for (const elem of subset) {
    if (!set.has(elem)) {
      return false;
    }
  }
  return true;
}

export function union(setA, setB) {
  const output = new Set(setA);
  for (const elem of setB) {
    output.add(elem);
  }
  return output;
}

export function intersection(setA, setB) {
  const output = new Set();
  for (const elem of setB) {
    if (setA.has(elem)) {
      output.add(elem);
    }
  }
  return output;
}

export function symmetricDifference(setA, setB) {
  const output = new Set(setA);
  for (const elem of setB) {
    if (output.has(elem)) {
      output.delete(elem);
    } else {
      output.add(elem);
    }
  }
  return output;
}

export function difference(setA, setB) {
  const output = new Set(setA);
  for (const elem of setB) {
    output.delete(elem);
  }
  return output;
}
